import React, { memo, useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import './Header.css';
import { publicHashUrl } from './publicUrl';

const imageName = require('./assets/img/gfn.png');
const imageuser = require('./assets/img/g12.png');

export const AHeader = () => {
  const op = useRef<OverlayPanel | null>(null);

  const handleLogout = () => {
    op.current?.hide();
    window.sessionStorage.removeItem('usertype');
  };

  return (
    <div className="layout-topbar app-topbar app-topbar--admin">
      <div className="layout-topbar-logo">
        <img src={imageName} alt="GearForNeed logo" width="200" />
      </div>
      <div className="app-topbar-spacer" />
      <ul className="app-user-nav">
        <li>
          <a
            className="nav-link app-user-trigger"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              op.current?.toggle(e);
            }}
            data-testid="user-image"
          >
            <img src={imageuser} className="avatar" alt="Admin" />
            <span className="hidden-xs app-user-name">Admin</span>
          </a>
        </li>
        <OverlayPanel ref={op}>
          <div className="app-overlay-links">
            <a href="/member/" data-testid="logout-link" onClick={handleLogout}>
              Sign out
            </a>
          </div>
        </OverlayPanel>
      </ul>
    </div>
  );
};

AHeader.displayName = 'AppTopbar';

export default memo(AHeader);
